import { Flex } from '@mantine/core';
import { createContext } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { useMipController } from './useMipController';
import { MIPCreate } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/MIPCreate';
import { MIPManage } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManage';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry.ts';
import { MessagesDashboard } from '@dealstack/frontend/app/pages/Project/MIP/Messages/MessagesDashboard';
import { MIP_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const MIPContext = createContext<null | ReturnType<typeof useMipController>>(null);

export const MIP = () => {
	const mipController = useMipController();
	const { dealId, mipId } = useRequiredParams('dealId', 'mipId');
	return (
		<Flex direction="column" h="100%" style={{ flexGrow: 1, overflow: 'auto' }}>
			<MIPContext.Provider value={mipController}>
				<SentryRoutes>
					<Route path={`${MIP_ROUTES.CREATE}/*`} element={<MIPCreate />} />
					<Route path={`${MIP_ROUTES.MANAGE}/*`} element={<MIPManage />} />
					<Route path={`${MIP_ROUTES.MESSAGES}/*`} element={<MessagesDashboard />} />
					<Route
						path="*"
						element={<Navigate to={mipManagePath('', { dealId, mipId })} />}
					/>
				</SentryRoutes>
			</MIPContext.Provider>
		</Flex>
	);
};
